import { classes, media, style } from "typestyle";
import colors from "../../styles/colors";
import fontSize from "../../styles/fontSize";
import mediaQueries, { upFrom } from "../../styles/mediaQueries";
import { mb2, mb3, mb4, mb5, mb8, ml8, pb12, pr12, pt4, px4 } from "../../styles/spacing";

export const ingress = classes(fontSize.xl, style(mb5));

export const badges = style(mb5);

export const description = classes(
  style(mb2, {
    whiteSpace: "pre-line",
    wordBreak: "break-word",
    $nest: {
      "&>*": {
        margin: 0,
        whiteSpace: "pre-line",
        wordBreak: "break-word",
      },
    },
  }),
);

export const mapImage = style({
  width: "100%",
  borderRadius: 10,
});

export const shortDescription = style({
  display: "flex",
  overflow: "hidden",
  flexDirection: "column",
  "-webkit-mask-image": "linear-gradient(to bottom, black 80%, transparent 100%)",
  maskImage: "linear-gradient(to bottom, black 80%, transparent 100%)",

  $nest: {
    "&>*": {
      marginBottom: "1.55rem",
    },
  },
});

export const container = style(
  pb12,
  pt4,
  px4,
  {
    margin: "0 auto",
  },
  media(mediaQueries.tablet, {
    maxWidth: 600,
    padding: "3rem 0",
  }),
  media(upFrom(mediaQueries.desktopSmall), {
    maxWidth: 800,
    padding: "3rem 0",
  }),
  media(upFrom(mediaQueries.desktopLarge), {
    maxWidth: 1000,
  }),
);

export const hero = style(
  media(upFrom(mediaQueries.desktopSmall), {
    display: "flex",
  }),
);

export const ticketBox = style(
  {
    flex: 1,
  },
  media(upFrom(mediaQueries.desktopSmall), ml8, { width: 400, minWidth: 400 }),
);

export const eventInfoBox = style(
  { minWidth: 0 },
  media(upFrom(mediaQueries.tablet), {
    minWidth: "368px",
  }),
  media(upFrom(mediaQueries.desktopLarge), {
    minWidth: "468px",
  }),
);

export const bottom = style({ backgroundColor: "#fff" });

export const infoBox = style(
  media(upFrom(mediaQueries.desktopSmall), {
    display: "flex",
  }),
  mb8,
);

export const infoBoxTitle = style(
  media(mediaQueries.desktopSmall, { width: 250 }, pr12),
  media(mediaQueries.desktopLarge, { width: 350 }, pr12),
  mb3,
);

export const infoBoxContent = classes(
  style({
    flex: 1,
  }),
);

export const infoText = classes(fontSize.lg);

export const addressText = classes(fontSize.lg);

export const informationText = style(mb3);

export const buttonGroup = style();

// map stuff
export const mapWrapper = style(
  {
    position: "relative",
  },
  mb2,
);

export const mapPin = style({
  position: "absolute",
  left: "calc(50% - 15px)",
  top: "calc(50% - 22px)",
});

export const directions = classes(fontSize.lg, style(mb4));

export const practicalInfoButton = style({
  background: "inherit",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  marginTop: "1rem",
  $nest: {
    "&:hover": {
      textDecoration: "underline",
      cursor: "pointer",
    },
    "&:disabled": {
      opacity: 1,
      color: "inherit",
      background: "inherit",
      $nest: {
        "&:hover": {
          cursor: "default",
          textDecoration: "none",
        },
      },
    },
  },
});

export const organizerInfoBox = style({
  display: "flex",
  alignItems: "center",
  flex: 1,
  border: "1px solid rgba(213, 218, 230, 1)",
  padding: "1rem 0.75rem",
  borderRadius: 12,
  marginTop: "16px",
  $nest: {
    "&>div:first-child": {
      marginRight: "8px",
    },
  },
});

export const organizerInfoBoxText = classes(
  style({
    display: "flex",
    flexDirection: "column",
    fontWeight: 500,
    $nest: {
      "&>*:first-child": {
        color: colors.grey[600],
        fontWeight: 400,
        opacity: 0.85,
      },
    },
  }),
  fontSize.sm,
);

export const organizerInfoBoxHeader = style({
  color: colors.grey[600],
  fontWeight: 400,
  opacity: 0.85,
});

export const organizerInfoHeader = style({
  display: "flex",
  fontWeight: 500,
  justifyContent: "space-between",
  width: "100%",
  marginLeft: "8px",
  alignItems: "center",
});

export const organizerInfo = style(
  {
    marginTop: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    $nest: {
      "&>div": {
        maxWidth: "100%",
      },
    },
  },
  media(upFrom(mediaQueries.tablet), {
    flexDirection: "row",
    $nest: {
      "&>div": {
        maxWidth: "calc(50% - 0.5rem)",
      },
    },
  }),
);

export const globe = style({
  background: colors.blue[200],
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  borderRadius: 1000,
  height: "32px",
  width: "32px",
  minWidth: "32px",
  marginRight: "8px",
});

export const chevron = style({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  borderRadius: 1000,
  height: "32px",
  width: "32px",
  border: "1px solid rgba(213, 218, 230, 1)",
});

export const expandButton = style({
  border: "1px solid rgba(229, 231, 235, 1)",
  borderRadius: "100%",
  padding: "0.5rem",
  backgroundColor: "white",
  $nest: {
    "&:hover": {
      cursor: "pointer",
    },
  },
});
